var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_300_5",
    "data-name": "Component 300 \\u2013 5",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24355",
    "data-name": "Group 24355",
    transform: "translate(0 24) rotate(-90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8602",
    "data-name": "Rectangle 8602",
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reload_update_refresh_icon_143703",
    d: "M13.778,5.111A10.662,10.662,0,0,0,10.964,2.34,5.612,5.612,0,0,0,7.856,1.5,6.352,6.352,0,0,0,1.5,8a6.443,6.443,0,0,0,6.356,6.5,6.441,6.441,0,0,0,4.767-2.167M14.5,1.5V5.111a.682.682,0,0,1-.722.722H10.167",
    transform: "translate(20 4) rotate(90)",
    fill: "none",
    stroke: "CurrentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.1e1a1ee613e2183eb703eb86c4f0f6b2.svg";
export { ForwardRef as ReactComponent };